// extracted by mini-css-extract-plugin
module.exports = {"container":"MultiChoice_container__1i5r5","options":"MultiChoice_options__YWg8Y"};